import { useContext } from "react";
import {
  setCookieConsent,
  setDeviceType,
  setMeasurements,
  setGAUserId,
  setMobileType,
} from "@actions/DeviceInfo";
import { DeviceInfoContext } from "@contexts/DeviceInfoProvider";
import { hasCookieConsent } from "@helpers/Cookie";
import getAnalyticsId from "@utils/get-analytics-id";

const getDeviceTypeFromUA = () => {
  const ua = navigator.userAgent;
  if (
    /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua
    )
  ) {
    return "mobile";
  }
  return "desktop";
};

const getMobileOSFromUA = () => {
  const ua = navigator.userAgent;
  if (/android/i.test(ua)) {
    return "android";
  } else if (
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  ) {
    return "iOS";
  }
  return "other";
};

const useDeviceInfo = () => {
  const context = useContext(DeviceInfoContext);

  if (!context) {
    throw new Error("useDeviceInfo must be used within DeviceInfoProvider");
  }

  const [state, dispatch] = context;

  const getDeviceType = () => {
    const deviceType = getDeviceTypeFromUA();
    dispatch(setDeviceType(deviceType));
  };

  const getMobileOS = () => {
    const mobileOS = getMobileOSFromUA();
    dispatch(setMobileType(mobileOS));
  };

  const getMeasurements = async () => {
    const width = document.body.offsetWidth;
    dispatch(
      setMeasurements({
        width,
      })
    );
  };

  const getCookieConsent = () => {
    const CONSENT_LEVEL = 2;

    const hasConsent = hasCookieConsent(CONSENT_LEVEL);

    dispatch(setCookieConsent(hasConsent));
  };
  const getGAUserId = () => {
    const analyticsId = getAnalyticsId();
    dispatch(setGAUserId(analyticsId));
  };

  return {
    getCookieConsent,
    getDeviceType,
    getMeasurements,
    getGAUserId,
    getMobileOS,
    ...state,
  };
};

export default useDeviceInfo;
